import { LABELS } from '@/constants/common/message.constants'
import { WEIGHT_DISPLAY_UNIT, type WeightDisplayUnit } from '@/libs/api/types'

/**
 * kg を指定の表示単位・小数桁数の数値に変換する（Issue #4905）
 */
export function convertKgToWeightDisplayUnit(
  kg: number,
  unit: WeightDisplayUnit
): number {
  return unit === WEIGHT_DISPLAY_UNIT.TON ? kg / 1000 : kg
}

/**
 * 小数桁数の選択肢ラベル（0 = 整数、1以上 = 小数第N位まで）
 */
export function getFractionDigitsLabel(fractionDigits: number): string {
  return fractionDigits === 0
    ? LABELS.WEIGHT_DISPLAY_FRACTION_DIGITS_INTEGER
    : LABELS.WEIGHT_DISPLAY_FRACTION_DIGITS(fractionDigits)
}
